import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingIndicatorService {
  private readonly isLoading = new BehaviorSubject<boolean>(false);
  private activeRequests = 0;
  private loadingTimeout: ReturnType<typeof setTimeout> | null = null;
  private hideTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly DELAY_MS = 300;
  // Grace period that bridges gaps between sequential request batches (e.g. guard → page cascade)
  private readonly HIDE_DELAY_MS = 150;

  show(): void {
    this.isLoading.next(true);
  }

  hide(): void {
    this.isLoading.next(false);
  }

  isVisible$(): Observable<boolean> {
    return this.isLoading.asObservable();
  }
  isVisible(): boolean {
    return this.isLoading.getValue();
  }

  incrementRequests(): void {
    // Cancel any pending hide — a new request arrived within the grace period
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    this.activeRequests++;

    if (this.activeRequests === 1) {
      this.loadingTimeout = setTimeout(() => {
        if (this.activeRequests > 0 && !this.isVisible()) {
          this.show();
        }
      }, this.DELAY_MS);
    }
  }

  decrementRequests(): number {
    this.activeRequests = Math.max(0, this.activeRequests - 1);

    if (this.activeRequests === 0) {
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      if (this.isVisible()) {
        this.hideTimeout = setTimeout(() => {
          if (this.activeRequests === 0) {
            this.hide();
          }
          this.hideTimeout = null;
        }, this.HIDE_DELAY_MS);
      }
    }

    return this.activeRequests;
  }

  reset(): void {
    this.activeRequests = 0;

    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    if (this.isVisible()) {
      this.hide();
    }
  }
}
